import React, { useEffect } from 'react';
import MarginConfigForm from './components/MarginConfigForm';
import { useIframeDetection } from './hooks/useIframeDetection';
import { getConfig, PageConfigModel, updateConfig } from './hooks/useAppConfig';
import './App.css';

const App: React.FC = () => {
  const { isInIframe, appId, clientKey, modelId } = useIframeDetection();
  const { config, loading, error } = getConfig(appId, clientKey, modelId);

  useEffect(() => {
  }, [isInIframe]);

  const handleSave = async (data: PageConfigModel) => {
    console.log('Configuración guardada:', data);
    try {
      await updateConfig(appId, clientKey, modelId, {
        name: config?.name || 'Configuración de márgenes',
        setting: data
      });
      console.log('Configuración actualizada exitosamente');
    } catch (error) {
      console.error('Error al actualizar configuración:', error);
    }
  };

  if (!isInIframe) {    
    return (
      <div className="app unauthorized">
        <div className="unauthorized-container">
          <div className="unauthorized-icon">🚫</div>
          <h1 className="unauthorized-title">Acceso No Autorizado</h1>
        </div>
      </div>
    )
  }

  return (
    <div className="app">
      <main className="app-main">
        {loading && <div className="loading">Cargando configuración...</div>}
        {!loading && !error && (
          <MarginConfigForm onSave={handleSave} page={config?.preferences.page || null} />
        )}
      </main>
    </div>
  );
};

export default App;
